import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function TwoPaths() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-208">
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline" data-id="element-209">
            Tienes dos caminos a partir de aquí
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-210">
          {/* Path A - Grayed out */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-[24px] p-8 md:p-10 border border-slate-200 opacity-70 grayscale" data-id="element-211">
            <h3 className="text-2xl font-display font-bold text-slate-500 mb-6" data-id="element-212">
              Camino A: No hacer nada
            </h3>
            <ul className="space-y-5" data-id="element-213">
              {['Seguir viendo a otros ganar desde casa', 'Seguir con la misma frustración financiera', 'Seguir esperando el momento perfecto que nunca llega', 'Seguir dependiendo de un solo ingreso'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-slate-500" data-id="element-214">
                  <div className="mt-1 flex-shrink-0" data-id="element-215">
                    <X className="w-5 h-5 text-slate-400" data-id="element-216" />
                  </div>
                  <span className="text-lg leading-relaxed" data-id="element-217">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Path B - Highlight in Pink */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-[24px] p-8 md:p-10 border-2 border-primary shadow-xl relative" data-id="element-218">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-219">
              EL CAMINO RECOMENDADO
            </div>
            <h3 className="text-2xl font-display font-bold text-dark mb-6" data-id="element-220">
              Camino B: Tomar acción hoy
            </h3>
            <ul className="space-y-5" data-id="element-221">
              {['Tener tu producto digital listo en 7 días', 'Empezar a generar ingresos desde tu celular', 'Invertir solo $6.36 en tu futuro', 'Unirte a cientos de mamás que ya lo lograron'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-dark font-medium" data-id="element-222">
                  <div className="mt-1 flex-shrink-0" data-id="element-223">
                    <Check className="w-5 h-5 text-primary" data-id="element-224" />
                  </div>
                  <span className="text-lg leading-relaxed" data-id="element-225">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-226">
          <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta inline-block w-full sm:w-auto bg-primary hover:bg-primary/90 text-white font-bold rounded-2xl px-8 py-5 text-lg md:text-xl shadow-lg shadow-primary/25 text-center relative overflow-hidden" animate={{
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-227">
            QUIERO EL CAMINO B — EMPEZAR POR $6.36 →
          </motion.a>
        </motion.div>
      </div>
    </section>;
}